// src/pages/Favoris.js
import { Card } from '../components/Card';
import { PageShell, PageTitle } from '../components/PageShell';
import { C, FONTS } from '../styles/theme';

export function Favoris({ favs, onFav, onBack }) {
  return (
    <PageShell>
      <button onClick={onBack} style={{
        background: 'none', border: 'none', color: C.textMid,
        fontSize: 14, fontWeight: '500', marginBottom: 24, cursor: 'pointer',
      }}>
        ← Retour
      </button>

      <PageTitle>Mes favoris</PageTitle>

      <p style={{ fontSize: 13, color: C.textLight, marginBottom: 28 }}>
        {favs.length === 0
          ? "Appuie sur 🤍 sur n'importe quelle carte pour la sauvegarder."
          : `${favs.length} carte${favs.length > 1 ? 's' : ''} sauvegardée${favs.length > 1 ? 's' : ''}`}
      </p>

      {favs.length === 0 && (
        <div style={{ textAlign: 'center', padding: '48px 0' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🤍</div>
          <div style={{ fontFamily: FONTS.display, fontStyle: 'italic', fontSize: 18, color: C.textMid }}>
            Tes cartes préférées apparaîtront ici
          </div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {favs.map((card, i) => (
          <div key={card.id} className="anim-fade-in" style={{ animationDelay: `${i * 0.04}s` }}>
            <Card card={card} isFav={true} onFav={onFav} compact />
          </div>
        ))}
      </div>
    </PageShell>
  );
}
